import React from 'react'
import {
  View,
  Dimensions,
  TouchableOpacity,
} from 'react-native'
import PropTypes from 'prop-types'
import WebView from 'react-native-webview'
import { getThemeImages, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'

import MigrationLottie from '../MigrationLottie'
import Modal from '../Modal'

import images from '../../Themes/Images'
import styles from './InfoModal.Styles'

const { height } = Dimensions.get('window')


function InfoModal({
  isVisible,
  closeModal,
}) {

  const theme = useTheme()

  const themeImages = getThemeImages(theme.name)

  return (
    <Modal
      visible={isVisible}
      close={() => closeModal()}
      title="vday_more_info"
    >
      <View style={styles.detailsContent}>
        <VFText
          i18nKey="vday_more_info"
          style={{ fontWeight: 'bold', fontSize: 20 }}
        />
        <TouchableOpacity onPress={() => closeModal()}>
          <Icon
            source={themeImages.ic_close}
            size={24}
            type="image"
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      <View
        style={{ height: height - (height / 3) }}
        onStartShouldSetResponder={() => true}>
        <WebView
          source={{ uri: ContentManager.translate('vday_more_info_url') }}
          style={styles.webView}
          startInLoadingState={true}
          renderLoading={() => (
            <View style={styles.lottieWrapper}>
              <MigrationLottie
                source={require('./loaderE60000.json')}
                style={styles.lottie}
              />
            </View>
          )}
        />
      </View>
    </Modal>
  )
}

InfoModal.defaultProps = {}

InfoModal.propTypes = {
  loading: PropTypes.bool,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
}

export default InfoModal
